import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs';
import { PillService } from '../../services/pill.service';
import { PILL } from '../../interfaces/pill.interface';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-pills',
  templateUrl: './pills.component.html',
  styleUrls: ['./pills.component.css']
})
export class PillsComponent implements OnInit {

  isDataLoaded: boolean = false;
  pillData: any;
  orderedPillData: any[] = [];

  pillStaticData: any = {
    titleTxt: '#pills',
    subtitleText: '#pills. info que da vida a los locales y que te da la vida a ti',
    mainText: 'Descubre las píldoras más interesantes que condensan lo mejor del fascinante y cambiante mundo del mercado Retail. Info financiera, la rabiosa actualidad del mercado, lo más destacado de la competencia, últimas legislaciones, las inversiones, el pulso de la IA en el sector retail. Toda la actualidad que llena de vida el mundo Retail. <b>¡Adelante!</b>',
  };

  constructor(private pillService: PillService) { }

  ngOnInit(): void {
    this.pillService.getPillsStatic().pipe(
      switchMap((resp) => {
        this.pillStaticData = resp;
        return this.pillService.getPillsData();
      })
    )
      .subscribe(
        {
          next: (data: any) => {

            this.pillData = data.data.pills.rows;

            // Test if datePublishing is null or empty and in that case, test if date is less than today
            this.pillData = data.data.pills.rows.filter(pill => pill.status === 1 && (!pill.datePublishing || pill.datePublishing === "" || new Date(pill.datePublishing) < new Date()));
            // Sort by date
            this.orderedPillData = this.pillData.sort((a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime());
            this.isDataLoaded = true;
          },
          error: (error) => { }
        })
  }

}
